// extracted by mini-css-extract-plugin
export default {"FilterTab":"Zones_FilterTab__1Znpx","Heading2":"Zones_Heading2__il-mm","Tables":"Zones_Tables__dtfA8"};